import { IsArray, IsNumber } from 'class-validator';

export class PhysicalCardProcessExternalRequestDto {
  /**
   * Each Physical Card ID in the array myst be a number.
   */
  @IsArray()
  @IsNumber({}, { each: true })
  physicalCardsIds: number[];
}
